var image_viewer_default = {
  "fontElementMap": "_84i4R",
  "imageContainer": "d6VpG",
  "expandButton": "aU52U",
  "expandIcon": "kgupr",
  "pointer": "fZm-X",
  "imageWrapper": "WKoTk",
  "imageRatio": "EvoAw",
  "image": "NTAim",
  "imageOverlay": "_9oEJ-",
  "imagePreload": "rVXER",
  "imageHighres": "_8AMWz",
  "onlyHighRes": "_1WapS",
  "image_loading": "_2nIQt"
};
export {
  image_viewer_default as default
};
//# sourceMappingURL=image-viewer-scss.js.map
